import { Controller } from "@hotwired/stimulus"
import 'toastr/build/toastr.css'
import * as toastr from 'toastr'

// Connects to data-controller="toastr"
export default class extends Controller {
  static values = {
    message: String,
    isAlert: Boolean,
    kind: String,
  }

  connect() {
    toastr.options.closeButton = true
    toastr.options.closeDuration = 500
    toastr.options.preventDuplicates = true

    if (this.messageValue) {
      if (this.isAlertValue || this.kindValue === 'alert') {
        toastr.error(this.messageValue)
      } else if (this.kindValue === 'info') {
        toastr.info(this.messageValue)
      } else if (this.kindValue === 'warning') {
        toastr.warning(this.messageValue)
      } else {
        toastr.success(this.messageValue)
      }
    }
  }
}
